import * as React from "react";
import Schema from "./schema";
import * as SC from "./stateChanges";

export { Schema };

class Form extends React.Component {
  constructor(props, schema) {
    super(props);
    this.schema = schema;
    this.init();
  }

  init() {
    const jsonSchema = this.schema.toJSON();
    const emptyKeys = Object.keys(jsonSchema).reduce((p, it) => {
      const defaultValue = jsonSchema[it].default
        ? jsonSchema[it].default
        : jsonSchema[it].type === "boolean"
        ? false
        : "";

      return {
        ...p,
        [it]: defaultValue
      };
    }, {});
    //eslint-disable-next-line
    this.state = {
      values: { ...emptyKeys },
      errors: { ...emptyKeys }
    };
  }

  update(field, value) {
    this.setState(SC.update(field, value));
  }

  getValues() {
    return {
      ...this.state.values
    };
  }

  setError(field, error) {
    this.setState(SC.setError(field, error));
  }

  validate() {
    return new Promise((resolve, reject) => {
      this.setState(SC.validate(this.schema), () => {
        const valid = Object.values(this.state.errors).filter(it => !!it).length === 0;

        if (valid) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }
}

export default Form;
